import { useAtomValue } from 'jotai';

import { ListViewGroup, ListViewRow, Stack } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';
import { EmptySection } from '@common/components/EmptySection';
import { InfoLineItem } from '@common/components/InfoLineItem';
import { PricedLineItem } from '@common/components/PricedLineItem';

import { useGetPreorderDetails } from '../../api/useGetPreorderDetails';
import { preorderDetailsDrawerAtom } from '../../atoms/preorderDetailsDrawerAtoms';

const SECTION_TITLE = 'Accessories';

export const AccessoriesSection = (): React.ReactNode => {
	const { preorderId } = useAtomValue(preorderDetailsDrawerAtom);
	const { data: preorderDetails, isLoading } = useGetPreorderDetails(
		preorderId ?? undefined,
	);

	if (isLoading) {
		return (
			<AccordionSection title={SECTION_TITLE} defaultExpanded>
				<Stack itemsSpacing='16'>
					<InfoLineItem title='Accessories' isLoading />
				</Stack>
			</AccordionSection>
		);
	}

	if (!preorderDetails) {
		return null;
	}

	const { accessories } = preorderDetails;

	return (
		<AccordionSection title={SECTION_TITLE} defaultExpanded>
			<Stack itemsSpacing='16'>
				<ListViewGroup>
					{accessories.length > 0 ? (
						accessories.map((accessory) => (
							<ListViewRow
								key={accessory.name}
								bottomContent={
									<PricedLineItem
										imageUrl={accessory.imgUrl}
										primaryLabel={accessory.name}
										secondaryLabel={
											accessory.count > 1
												? `Qty: ${accessory.count}`
												: undefined
										}
										price={accessory.basePrice}
									/>
								}
							/>
						))
					) : (
						<EmptySection message='No accessories on this preorder' />
					)}
				</ListViewGroup>
			</Stack>
		</AccordionSection>
	);
};
